import styled from "styled-components";

export const SectionBoxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-content: space-between;
  align-items: start;
  max-width: 1440px;
  margin: auto;
  gap: 1em;
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;
export const IconContianter = styled.div`
  width: 30px;
  height: 30px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(108, 115, 255, 0.4);
  border-radius: 50%;
  opacity: 0.2;
  @media screen and (max-width: 768px) {
  }
`;
export const SectionBox = styled.div`
  display: flex;
  flex-flow: column;
  padding: 1em;
  border: 1px solid rgba(255, 255, 255, 0.21);
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  gap: 1em;
  height: 100%;
  &:hover {
    cursor: pointer;
    transform: scale(0.95);
    border: 1px solid #ffffff;
    box-shadow: 0px 0px 6px #ffffff;
  }
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
  h2 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 150%;
    color: #ffffff;
    @media screen and (max-width: 1024px) {
      font-size: 18px;
      font-weight: 600;
      line-height: 27px;
      margin: 0;
    }
  }
  p {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #ffffff;
    @media screen and (max-width: 768px) {
      font-family: Poppins;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      letter-spacing: 0em;
      text-align: left;
    }
  }
`;

export const FeatureBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  @media screen and (max-width: 768px) {
    padding: 3px;
  }

  p {
    text-align: center;
    //styleName: Body 1 ;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #1d2646;
    @media screen and (max-width: 768px) {
      font-family: Poppins;
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      letter-spacing: 0em;
      text-align: center;
    }
  }
`;
export const FeatureBoxContainer = styled.div`
  display: flex;
`;
export const SectionFeatures = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0px 0px 200px 0px;
  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-bottom: 66px;
  }
`;
export const Featurecolumn = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  h2 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 120%;
    color: #1d2646;
    @media screen and (max-width: 768px) {
      font-family: Poppins;
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
      letter-spacing: 0em;
      text-align: left;
      width: 100%;
    }
  }
  p {
    //styleName: Body 1 ;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    @media screen and (max-width: 768px) {
      font-size: 16px;
      width: 100%;
    }
  }
  .featurescontainer {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    @media screen and (max-width: 768px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }
  .features {
    width: fit-content;
    padding: 0px 20px;
    height: 60px;
    border: 1px solid rgba(29, 38, 70, 0.17);
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 20px;
    @media screen and (max-width: 768px) {
      padding: 0px 10px;
      width: 90%;
      margin: 10px auto;
    }
    h3 {
      //styleName: Body 1 ;
      font-family: Poppins;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: center;
      color: #1d2646;
      margin-left: 10px;
      @media screen and (max-width: 768px) {
        font-size: 13px;
        margin-left: 0px;
      }
    }
  }
`;
export const FeatureImg = styled.div`
  position: relative;
  @media screen and (max-width: 1024px) {
    .featureimg {
      height: 307.24139404296875px;
      max-width: 100%;
    }
    order: 1;
    margin-top: 50px;
    margin-bottom: 50px;
  }
`;
export const Circle = styled.div`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  border-radius: 50%;
  background: ${(props) => props.bg};
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  @media screen and (max-width: 768px) {
    height: ${(props) => props.mheight};
    width: ${(props) => props.mwidth};
    top: ${(props) => props.mtop};
    left: ${(props) => props.mleft};
  }
`;

export const CollectionText = styled.div`
  h2 {
    //styleName: Header 2;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 120%;
    color: #1d2646;
    @media screen and (max-width: 768px) {
      font-size: 24px;
      line-height: 28.8px;
    }
  }
  p {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #1d2646;
    margin-bottom: 50px;
    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
  .collections {
    &_container {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    &_item {
      display: flex;
      align-items: center;
      width: 100%;
      h3 {
        //styleName: Body 1 ;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #1d2646;
        margin-left: 30px;
        @media screen and (max-width: 768px) {
          font-size: 13px;
          margin-left: 10px;
        }
      }
    }
    &_img {
      display: block;
      margin-right: 10px;
    }
  }
`;

export const ServicesText = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  h2 {
    //styleName: Header 1;
    font-family: Poppins;
    font-size: 60px;
    font-weight: 600;
    line-height: 66px;
    text-align: left;
    margin: 0;
    color: #1d2646;
    margin-top: 100px;
    @media screen and (max-width: 768px) {
      font-size: 36px;
      line-height: 39.6px;
      margin-top: 0px;
    }
  }
  p {
    //styleName: Body 1 ;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    @media screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 21px;
    }
  }
`;

export const Servicesimg = styled.div`
  display: flex;
  gap: 1em;
  width: 100%;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
  }
`;

export const Servicesimage = styled.img`
  max-width: 100%;
  height: ${(props) => props.height};
  position: relative;
  @media screen and (max-width: 768px) {
    width: ${(props) => props.mwidth};
    height: ${(props) => props.mheight};
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column;
  .footer {
    &_hidden {
      display: none !important;
      @media screen and (max-width: 768px) {
        display: flex !important;
      }
    }
    &_show {
      display: flex !important;
      @media screen and (max-width: 768px) {
        display: none !important;
      }
    }
    &_contacts {
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 1em;
      padding: 15px 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.21);
      @media screen and (max-width: 768px) {
        flex-flow: column;
      }
      &_contact {
        @media screen and (max-width: 768px) {
          width: 100%;
          display: flex;
          flex-flow: column;
          gap: 1em;
        }
      }
      &_social {
        display: flex;
        align-items: center;
        gap: 1em;
        @media screen and (max-width: 768px) {
          width: 100%;
          justify-content: start;
        }
        &_list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0;
          gap: 0.5em;
          @media screen and (max-width: 768px) {
            width: 100%;
            justify-content: start;
            align-items: flex-start;
          }
        }
        &_item {
          width: 37px;
          height: 37px;
          padding: 0.2em;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          @media screen and (max-width: 768px) {
            width: fit-content;
            height: fit-content;
          }
        }
        &_link {
          position: relative;
          display: flex;
          width: 36.06px;
          height: 36.06px;
          justify-content: center;
          align-items: center;
          @media screen and (max-width: 768px) {
          }
          &:hover {
            opacity: 0.4;
          }
        }
      }
      h3 {
        font-family: Poppins;
        font-size: 24px;
        font-weight: 600;
        line-height: 15px;
        letter-spacing: 0em;
        text-align: left;
        color: rgba(255, 255, 255, 0.75);
        margin: 0;
        @media screen and (max-width: 768px) {
          font-size: 18px;
        }
      }
    }
    &_contact {
      display: flex;
      justify-content: space-between;
      gap: 2em;
      @media screen and (max-width: 768px) {
        flex-flow: column;
        margin: 10px 0px;
        gap: 0.1em;
      }
      &_item {
        display: flex;
        align-items: center;

        @media screen and (max-width: 768px) {
          margin: 10px 0px;
          align-items: center;
        }
        h4 {
          font-family: "Poppins";
          font-style: normal;
          font-weight: 700;
          font-size: 19.23px;
          line-height: 118%;
          color: #ffffff;
          margin-left: 0.75em;
          @media screen and (max-width: 768px) {
            margin: 0;
            font-size: 16px;
            margin-left: 10px;
          }
        }
      }
    }
    &_menu {
      padding: 36px 0px;
      display: flex;
      justify-content: space-between;
      @media screen and (max-width: 768px) {
        flex-flow: column;
        border-bottom: 1px solid rgba(255, 255, 255, 0.21);
      }
      &_nav {
        display: flex;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex-flow: column;
          align-items: start;
        }
        &_list {
          display: flex;
          align-items: center;
          margin-top: 25px;
          @media screen and (max-width: 768px) {
            flex-flow: column;
            align-items: flex-start;
            padding: 0;
          }
        }
        &_item {
          @media screen and (max-width: 768px) {
            margin-bottom: 20px;
          }

          a {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 600;
            line-height: 19px;
            letter-spacing: 0px;
            text-align: center;
            margin-right: 28.0437px;
            color: #ffffff;
            @media screen and (max-width: 768px) {
              color: #ffffff;
              font-size: 14px;
            }
          }
        }
      }
    }
    &_copyright {
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media screen and (max-width: 768px) {
        flex-flow: column;
        align-items: flex-start;
        padding-top: 50px;
      }
      &_rights {
        display: flex;
        h4 {
          font-family: Poppins;
          font-size: 14px;
          font-weight: 500;
          line-height: 19px;
          letter-spacing: 0em;
          text-align: left;
          color: #ffffff;
          @media screen and (max-width: 768px) {
            font-size: 12px;
          }
        }
      }
      &_policy {
        display: flex;
        a {
          font-family: "Poppins";
          font-style: normal;
          font-weight: 500;
          font-size: 14.4225px;
          line-height: 129.5%;
          color: #ffffff;
          margin-right: 60px;
          &:last-of-type {
            margin-right: 0px;
          }
          @media screen and (max-width: 768px) {
            font-size: 12px;
            margin-right: 20px;
          }
        }
      }
    }
  }
`;
